import { t } from "i18next";
import React, { Dispatch, SetStateAction } from "react";
import CategoryPopover from "../../../components/Filters/subFilterPopover";

export type MaintenancesFilterType = {
  producers: Array<string>;
  equipment_type: Array<string>;
  maintenance_type: Array<string>;
};

export type MaintenancesCategoriesType = {
  unique_equipment_type_name: Array<string>;
  unique_producer_name: Array<string>;
  unique_maintenance_type: Array<string>;
};

type Props = {
  filterState: [MaintenancesFilterType, Dispatch<SetStateAction<MaintenancesFilterType>>];
  categories: MaintenancesCategoriesType;
};

const MaintenancesFilters = (props: Props) => {
  const producers = props.categories.unique_producer_name;
  const equipment_types = props.categories.unique_equipment_type_name;
  const maintenanceTypes = ["parts", "service"]; // Все состояния сенсоров

  const [filter, setFilter] = props.filterState; // Общий фильтр
  const [producersFilter, setProducersFilter] = React.useState(filter.producers); // Подфильтры категорий
  const [typesFilter, setTypesFilter] = React.useState(filter.equipment_type);
  const [maintenanceTypesFilter, setMaintenanceTypesFilterFilter] = React.useState(filter.maintenance_type);

  React.useEffect(() => {
    setFilter({
      ...filter,
      ...{
        producers: producersFilter,
        equipment_type: typesFilter,
        maintenance_type: maintenanceTypesFilter,
      },
    });
  }, [producersFilter, typesFilter, maintenanceTypesFilter]);

  return (
    <div className="flex gap-2">
      <CategoryPopover
        fixed
        searchbar={false}
        categoryName={t("type")}
        content={maintenanceTypes}
        filterState={[maintenanceTypesFilter, setMaintenanceTypesFilterFilter]}
      />
      <CategoryPopover
        categoryName={t("equipment_type_name")}
        content={equipment_types}
        filterState={[typesFilter, setTypesFilter]}
      />
      <CategoryPopover
        categoryName={t("producer")}
        content={producers}
        filterState={[producersFilter, setProducersFilter]}
      />
    </div>
  );
};

export default MaintenancesFilters;
